<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
  >

    <el-table-column
      label="参数规格"
      prop="paramSpec"
      align="center"
    />
    <el-table-column
      label="设备型号"
      prop="deviceModel"
      align="center"
    />
  </el-table>
</template>

<script setup>
import { ref } from 'vue';

const tableData = ref([
  {  paramSpec: '外形尺寸', deviceModel: '650cm*150cm*210cm' },
  {  paramSpec: '相机数量', deviceModel: '7Pcs' },
  {  paramSpec: '输送负载总重量', deviceModel: '5Kg/Pcs' },
  {  paramSpec: '产量', deviceModel: '3000Pcs/H' },
  { paramSpec: '传送带速度', deviceModel: '2m/s' },
  { paramSpec: '相机分辨率', deviceModel: '工业相机500w 智能读码相机1200w' },
  { paramSpec: '读码准确率', deviceModel: '大于 98%' },
  { paramSpec: '检测产品尺寸', deviceModel: '25cm*20cm*20cm' },
  {  paramSpec: '传送带宽度', deviceModel: '25cm' }
]);
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>